import { render, staticRenderFns } from "./ApNews.vue?vue&type=template&id=66124270&"
import script from "./ApNews.vue?vue&type=script&lang=js&"
export * from "./ApNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports